import React from 'react';

const ShortSVG = () => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M4 9h16v2H4V9zm0 4h10v2H4v-2z" />
    </svg>
  </>
);
export default ShortSVG;
